import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Tabs, Avatar, Radio } from "antd";
import type { RadioChangeEvent } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { cloneDeep } from "lodash-es";
import { publicPath } from "@/utils/base";
import http from "@/api";
import api from "@/api/auth";
import "./index.less";

import dataJson from "@/../public/data.json";
const prefix = "staging";

/** 暂时屏蔽：工作台应用 Tab 内「IDE 插件」入口（工具仍展示） */
const STAGING_BLOCKED_ENTRY_URLS = ["/protocol_plugin"];

function Staging() {
  const { staging, user, avatar_icon } = dataJson;
  const guideTypes: any = staging.guide_types;

  const [tabsList, setTabsList] = useState<any[]>([]);
  const [tabsValue, setTabsValue] = useState<string>(staging.staging_types[0].key);
  const [guideValue, setGuideValue] = useState<string>(guideTypes[0].value);
  const [guideData, setGuideData] = useState<any>(guideTypes[0]);
  const [documentArr, setDocumentArr] = useState<any>(staging.develop_document_arr);
  const userData = useSelector((state: any) => state.userData);
  const navigate = useNavigate();
  const location = useLocation();
  const { tabKey } = location.state || {};
  const [toolActiveIdx, setToolActiveIdx] = useState(-1);

  const guideValueChange = (e: RadioChangeEvent) => {
    setGuideValue(e.target.value);
    const guideFind = guideTypes.find((item: any) => e.target.value === item.value);
    setGuideData(guideFind);
  };

  const getAuthConfig = async () => {
    const res: any = await http.getAuthConfig();
    if (res?.code == 200) {
      const documentArrCopy = cloneDeep(documentArr);
      documentArrCopy.forEach((item: any) => {
        if (item.key === "1") {
          item.list.forEach((ele: any) => {
            ele.url = res?.data?.documentConfig[ele.key];
          });
        }
      });
      setDocumentArr(documentArrCopy);
    }
  };

  useEffect(() => {
    if (JSON.stringify(userData) !== "{}") {
      const tabsListMap = staging.staging_types.map((item: any) => {
        const items = (item.items || []).filter((ele: any) => !STAGING_BLOCKED_ENTRY_URLS.includes(ele.url));
        return {
          ...item,
          items,
          children: (
            <div className={`${prefix}-left-tabs-content`}>
              {items.map((ele: any) => {
                return (
                  <div
                    key={ele.key}
                    className={`${prefix}-left-tabs-content-item`}
                    onClick={() => {
                      navigate(publicPath + ele.url);
                    }}
                  >
                    <img src={ele.icon} alt="" />
                    {ele.label}
                  </div>
                );
              })}
            </div>
          ),
        };
      });
      setTabsList(tabsListMap);
    }
    if (tabKey) {
      setTabsValue(tabKey);
    }
  }, [userData]);

  useEffect(() => {
    api.bindKaihongProducts();
    getAuthConfig();
  }, []);

  return (
    <div className={prefix}>
      <div className={`${prefix}-left`}>
        <div className={`${prefix}-left-type`}>
          <Tabs
            activeKey={tabsValue}
            items={tabsList}
            className={`${prefix}-left-type-tabs`}
            onChange={(e) => {
              setTabsValue(e);
            }}
          />
        </div>
        <div className={`${prefix}-left-guide`}>
          <Radio.Group
            value={guideValue}
            options={guideTypes}
            optionType="button"
            onChange={guideValueChange}
            buttonStyle="solid"
            className={`${prefix}-left-guide-radio`}
          ></Radio.Group>
          <div className={`${prefix}-left-guide-title`}>{guideData.title}</div>
          <div className={`${prefix}-left-guide-content`}>
            {guideData.items.map((item: any) => {
              return (
                <div
                  key={item.key}
                  className={`${prefix}-left-guide-content-item`}
                  onClick={() => {
                    if (item.scrollTo) {
                      const element: any = document.getElementById("tool");
                      setToolActiveIdx(3);
                      element.scrollIntoView({
                        behavior: "smooth",
                      });
                    } else if (item._blank) {
                      window.open(publicPath + item.url, "_blank");
                    } else {
                      navigate(publicPath + item.url);
                    }
                  }}
                >
                  <img src={item.icon} alt="" className={`${prefix}-left-guide-content-icon`} />
                  <div className={`${prefix}-left-guide-content-label`}>{item.label}</div>
                  <div className={`${prefix}-left-guide-content-describe`}>{item.describe}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={`${prefix}-left-tool`} id="tool">
          <div className={`${prefix}-left-tool-title`}>{staging.development_tool}</div>
          <div className={`${prefix}-left-tool-content`}>
            {staging.guide_tool.map((item: any, i: number) => {
              return (
                <div
                  key={item.key}
                  className={`${prefix}-left-tool-content-item`}
                  style={toolActiveIdx === i ? { border: "2px solid #78a9ff" } : {}}
                  onClick={() => {
                    const targetUrl = `${item.url.includes("http") || item.key === "3" ? "" : publicPath}${item.url}`;
                    if (item.key === "4") {
                      const a = document.createElement("a");
                      a.href = targetUrl;
                      a.rel = "noreferrer";
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                    } else {
                      window.open(targetUrl, "_blank");
                    }
                  }}
                >
                  <img src={item.icon} alt="" className={`${prefix}-left-tool-content-icon`} />
                  <div className={`${prefix}-left-tool-content-label`}>{item.label}</div>
                  <div className={`${prefix}-left-tool-content-describe`}>{item.describe}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={`${prefix}-left-document`}>
          <div className={`${prefix}-left-document-title`}>{staging.develop_document}</div>
          <div className={`${prefix}-left-document-content`}>
            {documentArr.map((item: any, index: number) => {
              return (
                <div key={index}>
                  {item.list.map((ele: any, idx: number) => {
                    return (
                      <div
                        key={idx}
                        onClick={() => {
                          window.open(ele.url, "_black");
                        }}
                        className={`${prefix}-link-title`}
                      >
                        {ele.title}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className={`${prefix}-right`}>
        <div className={`${prefix}-right-account`}>
          <div className={`${prefix}-right-account-title`}>
            <span>{staging.account}</span>
            <Link to={`${publicPath}/user/info`}>
              {staging.detail}&nbsp;
              <RightOutlined />
            </Link>
          </div>
          <Avatar
            icon={<img src={userData?.avatar || avatar_icon} className={`${prefix}-right-account-avatar-icon`} />}
            className={`${prefix}-right-account-avatar`}
          />
          <div className={`${prefix}-right-account-info`}>
            <span>
              {user.account_name}
              {userData?.userName}
            </span>
            <span>
              {user.account_type}
              {user.user_type[userData?.additional?.userType as keyof typeof user.user_type]}
            </span>
          </div>
        </div>
        <div className={`${prefix}-right-message`}>
          <div className={`${prefix}-right-message-title`}>{staging.notify}</div>
          <div className={`${prefix}-right-message-empty`}>
            <img src={staging.message_empty_img} alt="" />
            <div>{staging.message_empty_text}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Staging;
